import { Bar, BarInfo, Coordinates } from './types';
import { generateRaidingParties } from './player-guild-generator';

const statuses = ['open', 'closed', 'busy', 'quiet'];

/**
 * Generates a random number between min (inclusive) and max (inclusive).
 * @param min - The minimum number
 * @param max - The maximum number
 * @returns A random number between min and max
 */
function getRandomNumber(min: number, max: number): number {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}

/**
 * Generates random bar information.
 * @returns An object containing random bar information.
 */
export function generateRandomBarInfo(): BarInfo {
    const tierSeed = getRandomNumber(1, 10);

    let tier: number;
    if (tierSeed <= 6) tier = 1;
    else if (tierSeed <= 9) tier = 2;
    else tier = 3;

    const status = statuses[getRandomNumber(0, statuses.length - 1)];
    const raidingParties = generateRaidingParties();

    return {
        tier,
        status,
        raidingParties,
    };
}

/**
 * Creates a bar with info and raiding parties.
 * @param placeName - The name of the bar
 * @param coordinates - The coordinates of the bar
 * @returns A bar object with info and raiding parties
 */
export function createBar(placeName: string, coordinates: Coordinates): Bar {
    const bar: Bar = {
        placeName,
        coordinates,
        info: generateRandomBarInfo(),
    };

    return bar;
}
